<div class="project-details-comments-list">
    <article *ngIf="messages!=null && messages.length==0" class="message-not-content">
        <core-helpers-box-alert-message-icon
            [text]="'There are currently no messages.'"
            [icon]="'no_messages'"
        ></core-helpers-box-alert-message-icon>
    </article>

    <ul class="comments-list" *ngIf="messages!=null && messages.length > 0">
        <li class="comments-timeline-item" *ngFor="let comment of messages; let i = index; trackBy: trackByMessageId">
            <core-message
                [message]="comment"
                [notesActionText]="accessWrite ? 'Add Notes' : 'See Notes'"
                [notesActionStyle]="accessWrite ? 'add-notes' : 'see-notes'"
                [canCreateNotes]="accessWrite"
                [delete]="comment.user.id == user.id"
                [prefixUrl]="prefixUrl"
                (onDelete)="onDeleted($event)"
                (refreshSignaturesNeeded)="onRefreshSignaturesNeeded()"
            ></core-message>

            <div class="message-attachments" *ngIf="comment?.attachments?.length > 0">
                <header>
                    <h4 *ngIf="isAttachmentsOpen(comment, i)" (click)="toggleAttachments(comment, i)"><em>{{comment?.attachments?.length}}</em> <span
                        class="arrow-up">Attachment{{comment?.attachments?.length > 1 ? 's':''}}</span></h4>
                    <h4 *ngIf="!isAttachmentsOpen(comment, i)" (click)="toggleAttachments(comment, i)"><em>{{comment?.attachments?.length}}</em> <span
                        class="arrow-down">Attachment{{comment?.attachments?.length > 1 ? 's':''}}</span></h4>
                </header>
                <div [hidden]="!isAttachmentsOpen(comment, i)" class="message-attachments-content messages">
                    <core-signed-files-list
                        [files]="comment.attachments"
                        [notes]="getNotesForMessage(comment)"
                        [annotationsUrl]="'/messages/' + comment.id"
                        [canCreateNotes]="accessWrite"
                        [annotationsUser]="user"
                        [menu]="fileMenu"
                        [scope]="scope"
                        (refreshSignaturesNeeded)="onRefreshSignaturesNeeded()"
                        (menuClick)="onFileMenuClick($event)"
                        (iconDownloadClick)="onFileIconDownloadClick($event)"
                        (annotationsSaved)="onNotesSaved(comment, $event)"
                    ></core-signed-files-list>
                </div>
            </div>
        </li>
    </ul>
    <div class="loader">
        <div class="dimmed" [hidden]="messages!=null">
            <div class="dimmed_avatar"></div>
            <div class="dimmed_info">
                <div class="dimmed_title"></div>
                <div class="dimmed_subtitle"></div>
            </div>
        </div>
        <!--  <core-helpers-box-loading [hidden]="messages!=null"></core-helpers-box-loading> -->
    </div>

   

</div>
